import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import useAuth from "hooks/UseAuth";

import { toast } from "react-toastify";
import { IconButton } from "shared/components/atoms/IconButton/IconButton";
import { SelectBox } from "shared/components/molecules/SelectBox/SelectBox";
import { AddressModal } from "shared/components/organisms/AddressModal/AddressModal";
import { DocsSubmitModal } from "shared/components/molecules/DocsSubmitModal/DocsSubmitModal";
import { SetDocumentModal } from "shared/components/organisms/SetDocumentModal/SetDocumentModal";
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar";
import { BankDataModal } from "shared/components/organisms/BankDataModal/BankDataModal";
import { DocsHeader } from "shared/components/molecules/DocsHeader/DocsHeader";

 import {
   ReactComponent as DocsIcon
 } from '../../assets/icons/docs-icon.svg'
 import {
   ReactComponent as FileUploadIcon
 } from '../../assets/icons/file-upload-icon.svg'
 import {
   ReactComponent as SelfieIcon
 } from '../../assets/icons/icon-metro-user.svg';
 import {
  ReactComponent as CameraIcon
} from '../../assets/icons/icon-feather-camera.svg';

import { HandleToggleState } from "./utils/HandleToggleState";
import { EnsureDocumentType } from "./utils/EnsureDocumentsType";

import { SubmitAddressFormData } from "./utils/SubmitAddressFormData";
import { SubmitPicDocFormData } from "./utils/SubmitPicDocFormData";
import { SubmitCertificateFormData } from "./utils/SubmitCertificateFormData";
import { SubmitBankData } from "./utils/SubmitBankData";

import { IAddressData, IBankData, IDocSubtypes } from "./interfaces";

import {
   BlueParagraph, GrayParagraph, Container, Content, Info, DocsForm, LabelHeader, FormLabel, MapPointerIcon, IDIcon, FormWrapper, CertifiedIcon, CreditCardIcon, CirclePlusIcon, TextInput, TextDetails, SubmitButton, PlusContainer, PlusButton, SelectWrapper, SelfieLabelWrapper
} from "./_sendingDocuments";
import api from "services/api";
import { SubmitSelfieFormData } from "./utils/SubmitSelfieFormData";
import { PageList } from "types/common";

export interface Bank {
  id: string;
  agency: string;
  agency_check_digit: string | null;
  account: string;
  account_check_digit: string;
  legal_name: string;
  document_number: string;
  bank_code_id: number;
  bank_account_type_id: number;
  status_id: number;
  user_id: string;
  created_at: string;
  updated_at: string;
}

/*(const srcToFile = (src: string|undefined, FileName: string, MimeType='jpg') => {
  if(!src) return null
  return (fetch(src)
      .then(function(res){return res.arrayBuffer();})
      .then(function(buf){return new File([buf], FileName, {type:MimeType});})
  );
}*/

export const SendingDocuments = () => {
  const { user } = useAuth();

  const [item, setItem] = useState({ value:'', label:'' });
  const [docTypes, setDocTypes] = useState([] as Array<IDocSubtypes>);

  const [addressData, setAddressData] = useState({
    street: '',
  } as IAddressData)
  const [picDocFile, setPicDocFile] = useState<File | undefined>();
  const [certificateFile, setCertificateFile] = useState<File | undefined>();
  const [selfieFile, setSelfieFile] = useState<File | undefined>();
  const [bankId, setBankId] = useState<string>('');
  const [bankData, setBankData] = useState({
    account: '',
  } as IBankData)
  const [addressChanged, setAddressChanged] = useState(false);

  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showPicDocModal, setShowPicDocModal] = useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [showBankDataModal, setShowBankDataModal] = useState(false);
  const [showDocsSubmitModal, setShowDocsSubmitModal] = useState(false);

  const [hideDocumentSection, setHideDocumentSection] = useState({
    hideIdDocument: false,
    hideCertificate: false,
    hideSelfie: false
  });

  const [disableForm, setDisableForm] = useState(true);
  const [isLoading, setIsLoading] = useState(false);



  useEffect(() => {
    ensureApiData()
    setAddressData(user.addresses[0])
    getBank()
  }, [])

  const ensureApiData = async () => {
    try {
      await EnsureDocumentType(setDocTypes)
      documentVisibility();
    } catch (error: any) {
      toast.error(error);
    }
  }

  const documentVisibility = () => {
    let documentVisibility = {
      hideIdDocument: false,
      hideCertificate: false,
      hideSelfie: false
    };
    user.documents.forEach(document => {
      if(document?.document_type_id.toString() === '1'){
        if(document.status_id === 2) {
          documentVisibility.hideIdDocument =  true;
        }
      }

      if(document?.document_type_id.toString() === '2'){
        if(document.status_id === 2) {
          documentVisibility.hideCertificate =  true;
        }
      }

      if(document?.document_type_id.toString() === '3'){
        if(document.status_id === 2) {
          documentVisibility.hideSelfie =  true;
        }
      }
    })

    setHideDocumentSection(documentVisibility);
  }

  const getBank = async () => {
    try {
      const response = await api.get<PageList<Bank>>('/banks');

      if (response.data.results.length > 0) {
        const bankGetted = response.data.results[0];

        setBankId(bankGetted.id);
        setBankData({
          account: bankGetted.account,
          account_check_digit: bankGetted.account_check_digit,
          agency: bankGetted.agency,
          bank_account_type_id: bankGetted.bank_account_type_id.toString(),
          bank_code_id: bankGetted.bank_code_id.toString(),
          document_number: bankGetted.document_number,
          legal_name: bankGetted.legal_name
        });
      
      }
    } catch (err: any) {
      
    }
  };

  useEffect(() => {
    handleValidateForm()
  }, [addressData, picDocFile, certificateFile, selfieFile, bankData,hideDocumentSection])

  const handleValidateForm = () => {
  
    if (addressData?.street && !!item && bankData?.account) {
    
      if(!hideDocumentSection.hideIdDocument && !picDocFile){
        setDisableForm(true)  
        return;
      }
      
      if(!hideDocumentSection.hideSelfie && !selfieFile){
        setDisableForm(true)  
        return;
      }

      setDisableForm(false)
    } else {
      setDisableForm(true)
    }
  }

  const handleSelfieChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;

    if (files && files.length) {
      setSelfieFile(files[0]);
    }
  }

  const handleFormSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      setIsLoading(true);

      const bank_response: any = await api.get('banks');
      const bank_id = bank_response?.data?.results[0]?.id || 'não pussuí';

      const promises = [
        SubmitBankData(bankData, bank_id)
      ]

      if(addressChanged){
        promises.push(SubmitAddressFormData({
          addressData, providerId: user?.provider?.id || '',
        }))
      }

      if (picDocFile) {
        promises.push(SubmitPicDocFormData({
          picDocFile, item
        }))
      }

      if (certificateFile) {
        promises.push(SubmitCertificateFormData(certificateFile))
      }

      if (selfieFile) {
        promises.push(SubmitSelfieFormData(selfieFile))
      }

      await Promise.all(promises)

      setShowDocsSubmitModal(true);
    } catch (error: any) {
      toast.error(error);
    } finally {
      setIsLoading(false);
    }
  }


  return (
    <Container>
      <DocsHeader />
      <Sidebar />

      <Content>
        <Info>
          <BlueParagraph>
            Por favor, insira as informações e documentações solicitadas para dar
            continuidade ao seu cadastro.
          </BlueParagraph>
          <GrayParagraph>
            Se precisar de ajuda, nossa equipe estará disponível
            para te auxiliar na aba Suporte do App.
          </GrayParagraph>
        </Info>

        <DocsForm onSubmit={handleFormSubmit}>
          <FormWrapper>
            <FormLabel>
              <MapPointerIcon />
              <LabelHeader>
                Qual é o seu endereço?
              </LabelHeader>
            </FormLabel>
            <TextInput
              type="text"
              placeholder="Endereço..."
              value={addressData?.street}
              readOnly
            />
            <IconButton
              type="button"
              icon={<MapPointerIcon />}
              onClick={() => HandleToggleState(setShowAddressModal)}
            >
              Inserir localização
            </IconButton>
            
            {!hideDocumentSection.hideIdDocument && 
            <>
              <FormLabel>
                <IDIcon />
                <LabelHeader>
                  Documento Original com Foto
                </LabelHeader>
              </FormLabel>
              <SelectWrapper>
                <SelectBox
                  placeholder="Selecione"
                  selectedItem={item}
                  setSelectedItem={setItem}
                  options={docTypes}
                />
              </SelectWrapper>
              <IconButton
                icon={<DocsIcon />}
                onClick={() => HandleToggleState(setShowPicDocModal)}
              >
                {picDocFile
                  ? picDocFile?.name
                  : 'Anexar Documento'
                }
              </IconButton>
            </>
            }

            {!hideDocumentSection.hideSelfie &&   
            <>
              <FormLabel>
                <SelfieIcon />
                <LabelHeader>
                  Selfie:
                </LabelHeader>
              </FormLabel>
              <TextDetails>
                Anexe aqui uma foto do seu rosto para confirmarmos sua identidade
              </TextDetails>
              <SelfieLabelWrapper htmlFor="setSelfieInput">
                <input type="file" accept="image/jpeg" hidden id="setSelfieInput" onChange={handleSelfieChange}/>
                <IconButton
                  icon={<CameraIcon />}
                  type="button"
                >
                  {selfieFile
                    ? selfieFile?.name
                    : 'Enviar foto'
                  }
                </IconButton>
              </SelfieLabelWrapper>
            </>
            }
            {!hideDocumentSection.hideCertificate &&   
            <>
              <FormLabel>
                <CertifiedIcon />
                <LabelHeader>
                  Anexe aqui seus certificados:
                </LabelHeader>
              </FormLabel>
              <TextDetails>
                Anexe todos os certificados referentes aos serviços que escolheu.
                Este envio é opcional.
              </TextDetails>
              <IconButton
                icon={<FileUploadIcon />}
                onClick={() => HandleToggleState(setShowCertificateModal)}
              >
                {certificateFile
                  ? certificateFile?.name
                  : 'Anexar certificados'
                }
              </IconButton>
            </>
            }
            <FormLabel>
              <CreditCardIcon />
              <LabelHeader>
                Dados Bancários
              </LabelHeader>
            </FormLabel>
            <PlusContainer>
              <PlusButton
                type="button"
                onClick={() => HandleToggleState(setShowBankDataModal)}
              >
                <CirclePlusIcon />
              </PlusButton>
              <TextInput
                type="text"
                placeholder="Selecione..."
                value={bankData?.account+bankData?.account_check_digit}
                readOnly
              />
            </PlusContainer>
            <SubmitButton
              type="submit"
              disabled={disableForm || isLoading}
            >
              Enviar documentação
            </SubmitButton>
          </FormWrapper>
        </DocsForm>
      </Content>
      {showAddressModal && (
        <AddressModal
          toggleModal={setShowAddressModal}
          setState={setAddressData}
          setAddressChanged={setAddressChanged}
        />
      )}
      {showPicDocModal && (
        <SetDocumentModal
          toggleModal={setShowPicDocModal}
          setDoc={setPicDocFile}
        />
      )}
      {showCertificateModal && (
        <SetDocumentModal
          toggleModal={setShowCertificateModal}
          setDoc={setCertificateFile}
        />
      )}
      {showBankDataModal && (
        <BankDataModal
          state={bankData}
          setState={setBankData}
          toggleModal={setShowBankDataModal}
        />
      )}
      {showDocsSubmitModal && (
        <DocsSubmitModal
          toggleModal={setShowDocsSubmitModal}
        />
      )}
    </Container>
  );
}
